import Currency from "./Currency";
import BaseModel from "./BaseModel";
import { ExchangeRateAttributes } from "../attributes/exchange-rate-attributes";

class ExchangeRate {
    id: number;
    multiplier: number;

    origin_currency: Currency;
    destination_currency: Currency;
  
    constructor(
        id:number,
        multiplier: number,
        originCurrency: Currency,
        destinationCurrency: Currency
    ) {

      this.id = id;
      this.multiplier = multiplier;
      this.origin_currency = originCurrency;
      this.destination_currency = destinationCurrency;
    }
  
    static fromJson(json: ExchangeRateAttributes): ExchangeRate | null {
      if (json === null || json === undefined) {
        return null;
      }
  
      return new ExchangeRate(
        json.id,
        json.multiplier,
        json.origin_currency != null ? Currency.fromJson(json.origin_currency) : null,
        json.destination_currency != null ? Currency.fromJson(json.destination_currency) : null,
      );
    }
  
  }
  
  export default ExchangeRate;